// extracted by mini-css-extract-plugin
export default {"container":"Testimonialprops_container__PXiqn","card":"Testimonialprops_card__D41uF","icon":"Testimonialprops_icon__S7+jT","text":"Testimonialprops_text__J-j+f"};